import { FC, HTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';
import { CheckBox } from 'src/UI';
import { useSearchMark } from 'src/Hooks';
import st from "./SelectBox.module.scss";

interface ISelectBoxBodyProps {
	minSearchLength?: number;
	isWait?: boolean;
	multiple?: boolean;
	searchText: string;
	selectedIds: Array<string>;
	options: Array<any>;
	valueField: string;
	titleField: string;
	
	onClickOption: ( item: any ) => void;
	onRenderOption?: ( item: any, isSelected: boolean, searchText: string, index: number, getHtml: (source: string, searchText: string) => string) => ReactNode;
	renderListTb?: () => ReactNode;

	onScroll?: (e: any) => void;
};

/** Контент выпадающего списка */
const SelectBoxBody: FC<ISelectBoxBodyProps> = ( props ) => {

	const { isWait, minSearchLength = 0, searchText, selectedIds = [],
		multiple = false, options = [], valueField, titleField,
		onClickOption, renderListTb, onRenderOption, onScroll
	} = props;

	// Для подсветки найденных значений
	const { getHtml } = useSearchMark( st.markItem );

	/** Возвращает  */
	const getHelperMessage = () => {
		const length = minSearchLength - searchText.length;
		if ( isWait ) 
			return "Ведется поиск...";
		else if ( minSearchLength > 0 && length > 0 )
			return `Для поиска введите хотя бы ${minSearchLength} символ(а)`;
		else if ( !options.length ) {
			return "Совпадений не найдено";
		}
		return "";
	};

	/** Отрисовка опции выпадающего списка */
	const renderOption = ( item: any, index: number ) => {
		const value = item[valueField];
		const title = item?.isNew ? item.newTitle : item[titleField];
		const isSelected = selectedIds.includes( value );
		return (
			<li 
				key={ "item__" + value + "-" + index}
				className={classNames(st.item, { [st.selected]: isSelected } )}
				onClick={ () => onClickOption( item ) }
			>
				{ 
					multiple && 
					<CheckBox
						name={"optionCB"+index}
						value={isSelected}
						className={st.checkBox}
					/>
				}
				{ 
					onRenderOption 
						? onRenderOption( item, isSelected, searchText, index, getHtml ) 
						: <div dangerouslySetInnerHTML={{ __html: getHtml(title, searchText) }} />  
				}
			</li>
		);
	};

	/** Отрисовка сообщения */
	const renderMessage = () => {
		const message = getHelperMessage();
		if ( !message ) return null;
		return (
			<p className={st.message}>
				{ message }
			</p>
		);
	};

	return (
		<>
			{ renderMessage() }
			<ul className={st.listWrapper} onScroll={onScroll}>
				{ options.map( renderOption )}
			</ul>
			{ !!renderListTb && renderListTb() }
		</>
	);
};

export default SelectBoxBody;
